export default "__VITE_ASSET__8AN7jNhE__"